import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f982c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lp-card lab-attachments"
}
const _hoisted_2 = { class: "lp-card-title" }
const _hoisted_3 = {
  key: 1,
  class: "lp-card lab-loading"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed, onMounted, toRef, watch } from 'vue';
import { useStore } from 'vuex';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import ItemShell from './ItemShell.vue';
import LabHero from './LabHero.vue';
import LabEnvironment from './LabEnvironment.vue';
import LabProgressCard from './LabProgressCard.vue';
import AttachmentList from './AttachmentList.vue';
import { usePathwayItemNav } from './usePathwayItemNav';
import { LabKind, labAttachmentItems } from './labs';
import { useLearningPathI18n } from '../view/learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    kind: null,
    pathwayId: null,
    resourceId: null
  },
  setup(__props: any) {

const props = __props as {
  kind: LabKind
  pathwayId: string
  resourceId: string
}



const store = useStore();
const { t, lang } = useLearningPathI18n();

const pathwayId = toRef(props, 'pathwayId');
const resourceId = toRef(props, 'resourceId');
const nav = usePathwayItemNav(pathwayId, props.kind, resourceId);

const pathway = computed(() => store.getters.getCurrentPathway);
const resource = computed(() => props.kind === 'challenge' ? store.getters.getChallenges : store.getters.getCurrentMachine);
// Evita mostrar por um instante o item anterior que ainda está no store
const ready = computed(() => resource.value && String(resource.value.id) === String(props.resourceId));

const attachments = computed(() => labAttachmentItems(resource.value?.attachments, lang.value));

const loadResource = () => {
  if (props.kind === 'challenge') {
    store.commit(Mutations.SET_CHALLENGES, {});
    store.dispatch(Actions.GET_CHALLENGE, props.resourceId);
  } else {
    store.commit(Mutations.SET_CURRENT_MACHINE, {});
    store.dispatch(Actions.GET_MACHINE, { id: props.resourceId });
  }
};

onMounted(() => {
  setCurrentPageTitle('Machines List');
  loadResource();
  nav.fetchSections();
  store.dispatch(Actions.GET_PATHWAY, props.pathwayId);
});

watch(resourceId, loadResource);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemShell, {
    pathway: _unref(pathway),
    "pathway-id": _unref(pathwayId),
    "item-title": _unref(ready) ? _unref(resource).name : '',
    sections: _unref(nav).sections.value,
    current: _unref(nav).current.value,
    prev: _unref(nav).prev.value,
    next: _unref(nav).next.value,
    "href-of": _unref(nav).hrefOf,
    "pathway-href": _unref(nav).pathwayHref.value
  }, {
    default: _withCtx(() => [
      (_unref(ready))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(LabHero, {
              kind: __props.kind,
              resource: _unref(resource),
              current: _unref(nav).current.value
            }, null, 8, ["kind", "resource", "current"]),
            (_openBlock(), _createBlock(LabEnvironment, {
              key: `env-${_unref(resource).id}`,
              kind: __props.kind,
              resource: _unref(resource),
              "pathway-id": _unref(pathwayId),
              onFlagAccepted: _unref(nav).fetchSections
            }, null, 8, ["kind", "resource", "pathway-id", "onFlagAccepted"])),
            (_openBlock(), _createBlock(LabProgressCard, {
              key: `progress-${_unref(resource).id}`,
              kind: __props.kind,
              resource: _unref(resource)
            }, null, 8, ["kind", "resource"])),
            (_unref(attachments).length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                  _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)(`${_unref(lang)}.common.attachments`)), 1),
                  _createVNode(AttachmentList, { items: _unref(attachments) }, null, 8, ["items"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
    ]),
    _: 1
  }, 8, ["pathway", "pathway-id", "item-title", "sections", "current", "prev", "next", "href-of", "pathway-href"]))
}
}

})